import React from "react";
import cn from "clsx";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import { isMobile } from "@/util";

const MapAreaDescription = ({
  name,
  address,
  phone,
  selected,
  onDescriptionClick,
  place,
  mapIconURL,
  showCustomIcon
  // activeCollectionPoint
}) => {
  const { t } = useTranslation("checkout");
  const areaIsAvailable = place.avl_limit > 0;
  return (
    <div
      className={`map_description`}
      onClick={
        () => onDescriptionClick(place)
        // areaIsAvailable > 0 && saveMapAddress
        //   ? e => {
        //       activeCollectionPoint && setActiveCollectionPoint(null);
        //       saveMapAddress(e, place);
        //     }
        //   : isMobile.any()
        //   ? () => setActiveCollectionPoint(place)
        //   : undefined
      }
    >
      <span
        className={cn(
          showCustomIcon ? "location_indicator_custom" : "location_indicator",
          {
            selected_location: selected,
            map_icon_bg: !Boolean(mapIconURL),
            inactive_point: !areaIsAvailable
          }
        )}
        {...(showCustomIcon &&
          mapIconURL && {
            style: { backgroundImage: `url(${mapIconURL})` }
          })}
      />
      <div
        className={cn("on_hover_des", {
          display: selected
          // || place === activeCollectionPoint
        })}
      >
        <div className="location_description">
          <h5>{name}</h5>
          <p>{address}</p>
          <p>{phone}</p>
          {!place.codSupport && (
            <p className="warning_message">
              {place.warning?.message || place.warning?.defaultMessage}
            </p>
          )}
          {place.deliveryMessages?.length > 0 &&
            place.deliveryMessages.map((msg, idx) => (
              <p key={idx} className="inner_msg delivery_message" dir="auto">
                {ReactHtmlParser(msg)}
              </p>
            ))}
          {!areaIsAvailable && (
            <div>
              <p className="unavailable">{t("storeTemporaryUnavailable")}</p>
            </div>
          )}
          {selected ? (
            <p className="selected_location_btn checked">{t("selected")}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MapAreaDescription;
